import React from "react";
import { Modal, Box } from "@mui/material";
import useTitanApp from "../../hooks/useTitanApp";
import PrescriptionCarditems from "./components/components/PrescriptionCarditems";
import VaccinationNewUI from "./components/components/VaccinationNewUI";


const VaccinationModal = ({
  show,
  handleClose,
  handleRemove,
}) => {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "min(95vw, 750px)",
    bgcolor: "transparent",
    outline: "none",
    p: 0,
    m: 0,
  };

  return (
    <Modal open={show} onClose={handleClose}>
      <Box sx={style}>
        <VaccinationNewUI
          handleClose={handleClose}
        />
      </Box>
    </Modal>
  );
};

export default VaccinationModal;
